<!--
 * @Description: 上传文件 读取文件base64
 * @Autor: lijinpeng
 * @Date: 2021-12-16 15:06:31
 * @LastEditors: WangYuhan
-->
<template>
  <div class="avatar-uploader" ref="upload">
    <nf-viewer
      class="el-upload"
      v-if="imageUrl"
      :images="[imageUrl]"
      :options="options"
      @mouseleave.native="isHover = false"
      @mouseover.native="isHover = true"
    >
      <img :src="imageUrl" class="avatar-uploader-img" />
      <div class="nf-mask actions-btn" v-if="isHover">
        <span
          class="actions-btn-item"
          @click="$refs.upload.querySelector('img.avatar-uploader-img').click()"
          title="查看大图"
        >
          <i class="el-icon-zoom-in" />
        </span>
        <span
          class="actions-btn-item"
          @click="$refs.upload.querySelector('input').click()"
          title="重新上传"
        >
          <i class="el-icon-upload" />
        </span>
        <!-- <span class="actions-btn-item" @click="handleDelete" title="删除图片">
          <i class="el-icon-delete" />
        </span> -->
      </div>
    </nf-viewer>
    <el-upload
      action
      :show-file-list="false"
      :auto-upload="false"
      :on-change="handleChange"
      v-show="!imageUrl"
    >
      <div class="avatar-uploader-icon"><i class="el-icon-plus" /></div>
      <div class="avatar-uploader-tips">{{ placeholder }}</div>
    </el-upload>
  </div>
</template>
<script>
export default {
  name: 'NfUploadFileBase64',
  props: {
    value: String,
    isOpenBase64: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isHover: false,
      imageUrl: '',
      options: {
        navbar: false,
        toolbar: {
          zoomIn: {
            show: 1,
            size: 'large',
          },
          zoomOut: {
            show: 1,
            size: 'large',
          },
          oneToOne: {
            show: 1,
            size: 'large',
          },
          reset: {
            show: 1,
            size: 'large',
          },
          rotateLeft: {
            show: 1,
            size: 'large',
          },
          rotateRight: {
            show: 1,
            size: 'large',
          },
        },
      },
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.imageUrl = newVal;
      },
      deep: true,
      immediate: true,
    },
    isHover(val) {
      console.log(val, 'val');
    },
  },
  methods: {
    getFileAsUrl(file, back) {
      // 读取文件base64
      const reader = new FileReader();
      // 读取文件base64
      reader.readAsDataURL(file);
      reader.onload = function (evt) {
        // 导出文件地址
        back(evt.target.result);
      };
    },
    handleChange(file) {
      if (this.$props.isOpenBase64) {
        this.getFileAsUrl(file.raw, img => {
          this.$emit('input', img);
          this.$emit('change', img);
        });
      } else {
        // URL.createObjectURL(file.raw)
        this.$emit('change', file);
      }
    },
    handleDelete() {
      this.isHover = false;
      this.imageUrl = '';
      this.$emit('input', '');
      this.$emit('delete', '');
    },
  },
};
</script>
<style lang="scss">
.avatar-uploader {
  .el-upload {
    width: 96px;
    height: 68px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409eff;
      color: #409eff;
      .avatar-uploader-icon {
        color: #409eff;
      }
    }
  }
  &-icon {
    font-size: 28px;
    color: #8c939d;
  }
  &-img {
    max-width: 100%;
    max-height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }
  &-tips {
    font-size: 12px;
  }
  .actions-btn {
    width: 96px;
    position: absolute;
    top: 20px;
    left: 0;
    z-index: 11;
    font-size: 28px;
    cursor: auto;
    &-item {
      margin: 0px 10px;
      cursor: pointer;
      &:hover {
        color: #409eff;
      }
    }
  }
}
</style>
